module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOICLb9TwlmGDVg1IBRA4aLAQCGdOcQLkvK6AAAAABJRU5ErkJggg=="